module.exports = __webpack_public_path__ + "static/media/eng_d_2480.3887c60b.vtt";